/* GENERATED by scripts/gen-tokens.ts from tokens.json — do not edit. */
export const tokens = {
  "color-paper": "#FFFFFF",
  "color-ink": "#2B2A33",
  "color-muted": "#5B5A6B",
  "color-cream": "#F4F4F6",
  "color-sand": "#FFF3C4",
  "color-line": "#E6DEC8",
  "color-coral": "#1F8A5B",
  "color-orange": "#1F8A5B",
  "color-yellow": "#FFD447",
  "color-violet": "#FF6B57",
  "color-coral-deep": "#16603F",
  "color-lavender-soft": "#E3F3FF",
  "color-on-gradient": "#FFFFFF",
  "color-on-yellow": "#2B2A33",
  "color-semantic-primary": "#1F8A5B",
  "color-semantic-primary-foreground": "#FFFFFF",
  "color-semantic-primary-text": "#16603F",
  "color-semantic-secondary": "#F4F4F6",
  "color-semantic-secondary-foreground": "#2B2A33",
  "color-semantic-muted": "#F4F4F6",
  "color-semantic-muted-foreground": "#5B5A6B",
  "color-semantic-border": "#E6DEC8",
  "color-semantic-input": "#E6DEC8",
  "color-semantic-ring": "#4FB0F0",
  "color-semantic-background": "#FFFFFF",
  "color-semantic-foreground": "#2B2A33",
  "color-semantic-card": "#FFFFFF",
  "color-semantic-destructive": "#FF6B57",
  "color-semantic-celebration": "#1F8A5B",
  "color-brand-marks-visa": "#1A1F71",
  "color-brand-marks-mastercard-red": "#EB001B",
  "color-brand-marks-mastercard-orange": "#F79E1B",
  "color-brand-marks-paypal-navy": "#003087",
  "color-brand-marks-paypal-blue": "#009CDE",
  "color-brand-marks-google-blue": "#4285F4",
  "color-brand-marks-apple-pay-pill": "#2B2A33",
  "gradient-primary": "linear-gradient(135deg, #1F8A5B 0%, #1F8A5B 100%)",
  "gradient-primary-css": "linear-gradient(135deg, #1F8A5B 0%, #1F8A5B 100%)",
  "gradient-sun": "linear-gradient(135deg, #FFD447 0%, #FFD447 100%)",
  "gradient-sun-css": "linear-gradient(135deg, #FFD447 0%, #FFD447 100%)",
  "gradient-celebration": "linear-gradient(135deg, #1F8A5B 0%, #16603F 100%)",
  "gradient-celebration-css": "linear-gradient(135deg, #1F8A5B 0%, #16603F 100%)",
  "gradient-thumbnail": "linear-gradient(160deg, #FFD447 0%, #FF6B57 100%)",
  "gradient-thumbnail-css": "linear-gradient(160deg, #FFD447 0%, #FF6B57 100%)",
  "gradient-surface-soft": "linear-gradient(135deg, #F4F4F6 0%, #FFF3C4 100%)",
  "gradient-surface-soft-css": "linear-gradient(135deg, #F4F4F6 0%, #FFF3C4 100%)",
  "gradient-auth-backdrop": "linear-gradient(180deg, #F4F4F6 0%, #FFFFFF 55%)",
  "gradient-auth-backdrop-css": "linear-gradient(180deg, #F4F4F6 0%, #FFFFFF 55%)",
  "gradient-progress-bar": "linear-gradient(90deg, #1F8A5B, #1F8A5B)",
  "gradient-progress-bar-css": "linear-gradient(90deg, #1F8A5B, #1F8A5B)",
  "gradient-text-primary": "linear-gradient(135deg, #1F8A5B, #16603F)",
  "gradient-text-primary-css": "linear-gradient(135deg, #1F8A5B, #16603F)",
  "font-family-sans": "\"Nunito\", \"Segoe UI\", Helvetica, Arial, sans-serif",
  "font-family-display": "\"Baloo 2\", \"Trebuchet MS\", Verdana, sans-serif",
  "font-weight-regular": "400",
  "font-weight-medium": "600",
  "font-weight-semibold": "600",
  "font-weight-bold": "700",
  "font-weight-extrabold": "800",
  "font-size-display": "44px",
  "font-size-display-mobile": "34px",
  "font-size-h1": "30px",
  "font-size-h1-large": "34px",
  "font-size-h2": "26px",
  "font-size-h2-landing": "34px",
  "font-size-h3": "22px",
  "font-size-title": "20px",
  "font-size-title-sm": "19px",
  "font-size-title-xs": "17px",
  "font-size-body": "15px",
  "font-size-body-sm": "14px",
  "font-size-caption": "13px",
  "font-size-micro": "12px",
  "font-size-tab": "10.5px",
  "font-size-stat-number": "30px",
  "font-line-height-display": "1.05",
  "font-line-height-heading": "1.1",
  "font-line-height-title": "1.15",
  "font-line-height-body": "1.5",
  "font-line-height-caption": "1.35",
  "font-letter-spacing-display": "-0.02em",
  "font-letter-spacing-heading": "-0.02em",
  "font-letter-spacing-title": "-0.01em",
  "font-letter-spacing-label": "0.06em",
  "space-1": "4px",
  "space-2": "6px",
  "space-3": "8px",
  "space-4": "10px",
  "space-5": "12px",
  "space-6": "14px",
  "space-7": "16px",
  "space-8": "18px",
  "space-9": "20px",
  "space-10": "22px",
  "space-11": "24px",
  "space-12": "28px",
  "space-13": "32px",
  "space-14": "36px",
  "space-15": "40px",
  "space-16": "48px",
  "space-17": "56px",
  "space-gutter-mobile": "20px",
  "space-gutter-desktop": "24px",
  "space-section-gap": "22px",
  "space-section-gap-desktop": "24px",
  "space-card-padding": "22px",
  "space-card-padding-lg": "24px",
  "space-tile-padding": "16px",
  "space-content-max-width": "680px",
  "space-landing-max-width": "1120px",
  "space-sidebar-width": "224px",
  "space-bottom-padding-mobile": "120px",
  "radius-pill": "999px",
  "radius-xl": "28px",
  "radius-lg": "22px",
  "radius-md": "18px",
  "radius-sm": "16px",
  "radius-xs": "14px",
  "radius-chip": "999px",
  "radius-thumbnail": "14px",
  "radius-thumbnail-lg": "18px",
  "radius-icon-badge": "18px",
  "radius-icon-badge-sm": "12px",
  "radius-tab-bar": "28px",
  "radius-tab-item": "22px",
  "radius-device-stack": "32px",
  "shadow-card": "0 1px 0 rgba(43,42,51,0.04)",
  "shadow-card-raised": "0 6px 20px rgba(43,42,51,0.08)",
  "shadow-float": "0 18px 40px rgba(43,42,51,0.16)",
  "shadow-primary-glow": "0 3px 0 #16603F",
  "shadow-primary-glow-strong": "0 6px 18px rgba(31,138,91,0.28)",
  "shadow-tab-bar": "0 10px 30px rgba(43,42,51,0.14)",
  "shadow-segment-thumb": "0 2px 8px rgba(43,42,51,0.10)",
  "shadow-hero": "0 30px 60px rgba(43,42,51,0.22)",
  "border-chip": "1.5px solid #E6DEC8",
  "border-input": "1.5px solid #E6DEC8",
  "border-input-focus": "2px solid #1F8A5B",
  "border-dropzone": "3px dashed #1F8A5B",
  "border-empty-dashed": "2px dashed #E6DEC8",
  "border-avatar-ring": "3px solid #FFFFFF",
  "size-tap-min": "44px",
  "size-button-md": "46px",
  "size-button-lg": "50px",
  "size-button-xl": "56px",
  "size-input-height": "48px",
  "size-tab-bar-item": "56px",
  "size-icon-nav": "24px",
  "size-icon-tile": "26px",
  "size-icon-hero": "32px",
  "size-avatar-sm": "28px",
  "size-avatar-md": "36px",
  "size-avatar-lg": "48px",
  "size-avatar-xl": "64px",
  "size-progress-bar": "5px",
  "size-progress-bar-lg": "8px",
  "breakpoint-mobile-max": "767px",
  "breakpoint-mobile-gutter": "20px",
  "breakpoint-mobile-columns": "1px",
  "breakpoint-desktop-min": "768px",
  "breakpoint-desktop-gutter": "24px",
  "breakpoint-desktop-content-max-width": "680px",
  "breakpoint-wide-min": "1120px",
  "motion-easing-standard": "ease-out",
  "motion-easing-in-out": "ease-in-out",
  "motion-duration-fast": "200ms",
  "motion-duration-screen-in": "300ms",
  "motion-duration-detail-in": "250ms",
  "motion-duration-pop": "500ms",
  "motion-duration-confetti": "1100ms",
  "motion-duration-bounce": "2400ms",
  "motion-duration-bounce-fast": "1600ms",
  "motion-duration-float": "5000ms",
  "motion-duration-scan": "2200ms",
  "motion-duration-progress-fill": "3400ms",
  "motion-duration-stage-rotate": "1400ms",
  "icon-set": "Phosphor Icons, duotone weight; emoji stay as text",
  "icon-sizes-nav": "24px",
  "icon-sizes-inline": "16px",
  "icon-sizes-tile": "26px",
  "icon-sizes-hero": "32px",
  "funnel-column-max-width": "480px",
  "funnel-column-gutter": "20px",
  "funnel-column-backdrop": "#F4F4F6",
  "funnel-header-height": "56px",
  "funnel-header-icon": "26px",
  "funnel-progress-segments": "5px",
  "funnel-progress-height": "5px",
  "funnel-progress-gap": "6px",
  "funnel-progress-track": "#E6DEC8",
  "funnel-progress-fill": "linear-gradient(90deg,#1F8A5B,#1F8A5B)",
  "funnel-timer-card-bg": "linear-gradient(135deg,#1F8A5B,#16603F)",
  "funnel-timer-card-fill": "linear-gradient(90deg,rgba(255,255,255,.18),rgba(255,255,255,.18))",
  "funnel-timer-card-digit-box": "rgba(255,255,255,.16)",
  "funnel-timer-card-digit": "22/800",
  "funnel-green-bg": "#DFF5E8",
  "funnel-green-fg": "#16603F",
  "funnel-green-text": "#2B2A33",
  "funnel-ig-gradient": "linear-gradient(135deg,#F9CE34,#EE2A7B 55%,#6228D7)",
  "funnel-brand-red": "#C8102E",
  "funnel-option-row-min-height": "56px",
  "funnel-option-row-radius": "16px",
  "funnel-option-row-border": "1.5px #E6DEC8",
  "funnel-option-row-selected-border": "#1F8A5B",
  "funnel-option-row-selected-fill": "#DFF5E8",
  "funnel-option-row-glyph-badge": "34px",
  "funnel-two-up-radius": "22px",
  "funnel-two-up-icon-badge": "64px",
  "funnel-two-up-primary-tile": "gradient.primary",
  "funnel-two-up-secondary-tile": "#F4F4F6",
  "funnel-loader-ring": "96px",
  "funnel-loader-step-ms": "1800,1800,1800",
  "funnel-loader-detail-reveal": "fk-in 300ms",
  "funnel-loader-variants": "numbers,profile,plan,reviews",
  "funnel-motion-screen-in": "300px",
  "funnel-motion-fast": "200px",
  "funnel-motion-pop": "500px",
  "funnel-motion-confetti": "1100px",
  "funnel-motion-scan": "2200px",
  "funnel-motion-auto-advance": "250px"
} as const;

export type TokenName = keyof typeof tokens;

export const tk = (name: TokenName): string => tokens[name];
